import HandleResponses from '@common/utils/handleResponses';
import tmsMdmAxiosInstance from '../../../tms-mdm-axios';

const actions = {
  async calculateRate(_, params) {
    try {
      const result = await tmsMdmAxiosInstance('contract/calculate', { params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async fetchPincodeRatecard(_, pincode) {
    try {
      const result = await tmsMdmAxiosInstance(`/pincodeRatecard/${pincode}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
